import type { FunctionComponent } from 'react';
import loadable from '@loadable/component';
import { PAGE_TYPES } from 'Src/constants';
import { useAppContext } from '../App/App.context';
import { PageComponentMap } from 'Src/store/context/types';
const components: Partial<PageComponentMap> = {
    [PAGE_TYPES.index]: loadable({
        chunkName() { return "805f38f6e98e09fe4c8244c178c90706"; },
        requireAsync() {
            if (true) {
                return import(/*webpackChunkName: "805f38f6e98e09fe4c8244c178c90706"*/
                'Src/pages/IndexPage');
            }
            else {
                return Promise.resolve(this.requireSync());
            }
        },
        isReady() {
            if (typeof __webpack_modules__ !== "undefined") {
                return Boolean(__webpack_modules__[this.resolve()]);
            }
            return false;
        },
        requireSync() {
            const id = this.resolve();
            if (typeof __webpack_require__ !== "undefined") {
                const module = __webpack_require__(id);
                if (typeof module.default === "undefined")
                    module.default = module;
                return module;
            }
        },
        resolve() {
            if (false) {
                return require.resolve("Src/pages/IndexPage");
            }
            else {
                return require.resolveWeak("Src/pages/IndexPage");
            }
        }
    }),
    [PAGE_TYPES.article]: loadable({
        chunkName() { return "9ba2f1f4b4ecdb5338c6f7a7a65c2f07"; },
        requireAsync() {
            if (true) {
                return import(/*webpackChunkName: "9ba2f1f4b4ecdb5338c6f7a7a65c2f07"*/
                'Src/pages/ArticlePage');
            }
            else {
                return Promise.resolve(this.requireSync());
            }
        },
        isReady() {
            if (typeof __webpack_modules__ !== "undefined") {
                return Boolean(__webpack_modules__[this.resolve()]);
            }
            return false;
        },
        requireSync() {
            const id = this.resolve();
            if (typeof __webpack_require__ !== "undefined") {
                const module = __webpack_require__(id);
                if (typeof module.default === "undefined")
                    module.default = module;
                return module;
            }
        },
        resolve() {
            if (false) {
                return require.resolve("Src/pages/ArticlePage");
            }
            else {
                return require.resolveWeak("Src/pages/ArticlePage");
            }
        }
    }),
    [PAGE_TYPES.kindDetail]: loadable({
        chunkName() { return "228097e7f9c72348c433a6a128bedb2d"; },
        requireAsync() {
            if (true) {
                return import(/*webpackChunkName: "228097e7f9c72348c433a6a128bedb2d"*/
                'Src/pages/PetsKindPage');
            }
            else {
                return Promise.resolve(this.requireSync());
            }
        },
        isReady() {
            if (typeof __webpack_modules__ !== "undefined") {
                return Boolean(__webpack_modules__[this.resolve()]);
            }
            return false;
        },
        requireSync() {
            const id = this.resolve();
            if (typeof __webpack_require__ !== "undefined") {
                const module = __webpack_require__(id);
                if (typeof module.default === "undefined")
                    module.default = module;
                return module;
            }
        },
        resolve() {
            if (false) {
                return require.resolve("Src/pages/PetsKindPage");
            }
            else {
                return require.resolveWeak("Src/pages/PetsKindPage");
            }
        }
    }),
    [PAGE_TYPES.kindRating]: loadable({
        chunkName() { return "763b02623117f72d297dcd74e5d3fac0"; },
        requireAsync() {
            if (true) {
                return import(/*webpackChunkName: "763b02623117f72d297dcd74e5d3fac0"*/
                'Src/pages/KindRatingPage');
            }
            else {
                return Promise.resolve(this.requireSync());
            }
        },
        isReady() {
            if (typeof __webpack_modules__ !== "undefined") {
                return Boolean(__webpack_modules__[this.resolve()]);
            }
            return false;
        },
        requireSync() {
            const id = this.resolve();
            if (typeof __webpack_require__ !== "undefined") {
                const module = __webpack_require__(id);
                if (typeof module.default === "undefined")
                    module.default = module;
                return module;
            }
        },
        resolve() {
            if (false) {
                return require.resolve("Src/pages/KindRatingPage");
            }
            else {
                return require.resolveWeak("Src/pages/KindRatingPage");
            }
        }
    }),
    [PAGE_TYPES.kindAlphabet]: loadable({
        chunkName() { return "08d49519829f3cb1493f5b998daa5fde"; },
        requireAsync() {
            if (true) {
                return import(/*webpackChunkName: "08d49519829f3cb1493f5b998daa5fde"*/
                'Src/pages/KindAlphabetPage');
            }
            else {
                return Promise.resolve(this.requireSync());
            }
        },
        isReady() {
            if (typeof __webpack_modules__ !== "undefined") {
                return Boolean(__webpack_modules__[this.resolve()]);
            }
            return false;
        },
        requireSync() {
            const id = this.resolve();
            if (typeof __webpack_require__ !== "undefined") {
                const module = __webpack_require__(id);
                if (typeof module.default === "undefined")
                    module.default = module;
                return module;
            }
        },
        resolve() {
            if (false) {
                return require.resolve("Src/pages/KindAlphabetPage");
            }
            else {
                return require.resolveWeak("Src/pages/KindAlphabetPage");
            }
        }
    }),
    [PAGE_TYPES.kindCompilation]: loadable({
        chunkName() { return "03bfbfdfdc3ef5e2a4ad5ef7af2cfe11"; },
        requireAsync() {
            if (true) {
                return import(/*webpackChunkName: "03bfbfdfdc3ef5e2a4ad5ef7af2cfe11"*/
                'Src/pages/KindCompilationPage');
            }
            else {
                return Promise.resolve(this.requireSync());
            }
        },
        isReady() {
            if (typeof __webpack_modules__ !== "undefined") {
                return Boolean(__webpack_modules__[this.resolve()]);
            }
            return false;
        },
        requireSync() {
            const id = this.resolve();
            if (typeof __webpack_require__ !== "undefined") {
                const module = __webpack_require__(id);
                if (typeof module.default === "undefined")
                    module.default = module;
                return module;
            }
        },
        resolve() {
            if (false) {
                return require.resolve("Src/pages/KindCompilationPage");
            }
            else {
                return require.resolveWeak("Src/pages/KindCompilationPage");
            }
        }
    }),
    [PAGE_TYPES.error]: loadable({
        chunkName() { return "5d5826a8b40d91804e091b2d75b044c6"; },
        requireAsync() {
            if (true) {
                return import(/*webpackChunkName: "5d5826a8b40d91804e091b2d75b044c6"*/
                'Src/pages/ErrorPage');
            }
            else {
                return Promise.resolve(this.requireSync());
            }
        },
        isReady() {
            if (typeof __webpack_modules__ !== "undefined") {
                return Boolean(__webpack_modules__[this.resolve()]);
            }
            return false;
        },
        requireSync() {
            const id = this.resolve();
            if (typeof __webpack_require__ !== "undefined") {
                const module = __webpack_require__(id);
                if (typeof module.default === "undefined")
                    module.default = module;
                return module;
            }
        },
        resolve() {
            if (false) {
                return require.resolve("Src/pages/ErrorPage");
            }
            else {
                return require.resolveWeak("Src/pages/ErrorPage");
            }
        }
    }),
    [PAGE_TYPES.rubric]: loadable({
        chunkName() { return "176a6b30c797d21cdc42158880071ce7"; },
        requireAsync() {
            if (true) {
                return import(/*webpackChunkName: "176a6b30c797d21cdc42158880071ce7"*/
                'Src/pages/RubricPage');
            }
            else {
                return Promise.resolve(this.requireSync());
            }
        },
        isReady() {
            if (typeof __webpack_modules__ !== "undefined") {
                return Boolean(__webpack_modules__[this.resolve()]);
            }
            return false;
        },
        requireSync() {
            const id = this.resolve();
            if (typeof __webpack_require__ !== "undefined") {
                const module = __webpack_require__(id);
                if (typeof module.default === "undefined")
                    module.default = module;
                return module;
            }
        },
        resolve() {
            if (false) {
                return require.resolve("Src/pages/RubricPage");
            }
            else {
                return require.resolveWeak("Src/pages/RubricPage");
            }
        }
    }),
    [PAGE_TYPES.consulationMain]: loadable({
        chunkName() { return "febe5d8d0bad2e72b662473e62bba047"; },
        requireAsync() {
            if (true) {
                return import(/*webpackChunkName: "febe5d8d0bad2e72b662473e62bba047"*/
                'Src/pages/ConsultationMainPage');
            }
            else {
                return Promise.resolve(this.requireSync());
            }
        },
        isReady() {
            if (typeof __webpack_modules__ !== "undefined") {
                return Boolean(__webpack_modules__[this.resolve()]);
            }
            return false;
        },
        requireSync() {
            const id = this.resolve();
            if (typeof __webpack_require__ !== "undefined") {
                const module = __webpack_require__(id);
                if (typeof module.default === "undefined")
                    module.default = module;
                return module;
            }
        },
        resolve() {
            if (false) {
                return require.resolve("Src/pages/ConsultationMainPage");
            }
            else {
                return require.resolveWeak("Src/pages/ConsultationMainPage");
            }
        }
    }),
    [PAGE_TYPES.consultationRubric]: loadable({
        chunkName() { return "b44a0c32e3634db570faeafab68a38ac"; },
        requireAsync() {
            if (true) {
                return import(/*webpackChunkName: "b44a0c32e3634db570faeafab68a38ac"*/
                'Src/pages/ConsultationRubricPage');
            }
            else {
                return Promise.resolve(this.requireSync());
            }
        },
        isReady() {
            if (typeof __webpack_modules__ !== "undefined") {
                return Boolean(__webpack_modules__[this.resolve()]);
            }
            return false;
        },
        requireSync() {
            const id = this.resolve();
            if (typeof __webpack_require__ !== "undefined") {
                const module = __webpack_require__(id);
                if (typeof module.default === "undefined")
                    module.default = module;
                return module;
            }
        },
        resolve() {
            if (false) {
                return require.resolve("Src/pages/ConsultationRubricPage");
            }
            else {
                return require.resolveWeak("Src/pages/ConsultationRubricPage");
            }
        }
    }),
    [PAGE_TYPES.consultantListing]: loadable({
        chunkName() { return "fcc3582b882b94b0d96373437ac93d80"; },
        requireAsync() {
            if (true) {
                return import(/*webpackChunkName: "fcc3582b882b94b0d96373437ac93d80"*/
                'Src/pages/ConsultantListingPage');
            }
            else {
                return Promise.resolve(this.requireSync());
            }
        },
        isReady() {
            if (typeof __webpack_modules__ !== "undefined") {
                return Boolean(__webpack_modules__[this.resolve()]);
            }
            return false;
        },
        requireSync() {
            const id = this.resolve();
            if (typeof __webpack_require__ !== "undefined") {
                const module = __webpack_require__(id);
                if (typeof module.default === "undefined")
                    module.default = module;
                return module;
            }
        },
        resolve() {
            if (false) {
                return require.resolve("Src/pages/ConsultantListingPage");
            }
            else {
                return require.resolveWeak("Src/pages/ConsultantListingPage");
            }
        }
    }),
    [PAGE_TYPES.consultationConsultant]: loadable({
        chunkName() { return "7ddb46b6447613b06c4353c7c691c0dc"; },
        requireAsync() {
            if (true) {
                return import(/*webpackChunkName: "7ddb46b6447613b06c4353c7c691c0dc"*/
                'Src/pages/ConsultantPage');
            }
            else {
                return Promise.resolve(this.requireSync());
            }
        },
        isReady() {
            if (typeof __webpack_modules__ !== "undefined") {
                return Boolean(__webpack_modules__[this.resolve()]);
            }
            return false;
        },
        requireSync() {
            const id = this.resolve();
            if (typeof __webpack_require__ !== "undefined") {
                const module = __webpack_require__(id);
                if (typeof module.default === "undefined")
                    module.default = module;
                return module;
            }
        },
        resolve() {
            if (false) {
                return require.resolve("Src/pages/ConsultantPage");
            }
            else {
                return require.resolveWeak("Src/pages/ConsultantPage");
            }
        }
    }),
    [PAGE_TYPES.consultantQuestion]: loadable({
        chunkName() { return "acac0cd0aa838812ab5c98b4546f1736"; },
        requireAsync() {
            if (true) {
                return import(/*webpackChunkName: "acac0cd0aa838812ab5c98b4546f1736"*/
                'Src/pages/ConsultationQuestionPage');
            }
            else {
                return Promise.resolve(this.requireSync());
            }
        },
        isReady() {
            if (typeof __webpack_modules__ !== "undefined") {
                return Boolean(__webpack_modules__[this.resolve()]);
            }
            return false;
        },
        requireSync() {
            const id = this.resolve();
            if (typeof __webpack_require__ !== "undefined") {
                const module = __webpack_require__(id);
                if (typeof module.default === "undefined")
                    module.default = module;
                return module;
            }
        },
        resolve() {
            if (false) {
                return require.resolve("Src/pages/ConsultationQuestionPage");
            }
            else {
                return require.resolveWeak("Src/pages/ConsultationQuestionPage");
            }
        }
    }),
    [PAGE_TYPES.search]: loadable({
        chunkName() { return "2b4601f7baccec3109a013a1b33284d5"; },
        requireAsync() {
            if (true) {
                return import(/*webpackChunkName: "2b4601f7baccec3109a013a1b33284d5"*/
                'Src/pages/SearchPage/SearchPage');
            }
            else {
                return Promise.resolve(this.requireSync());
            }
        },
        isReady() {
            if (typeof __webpack_modules__ !== "undefined") {
                return Boolean(__webpack_modules__[this.resolve()]);
            }
            return false;
        },
        requireSync() {
            const id = this.resolve();
            if (typeof __webpack_require__ !== "undefined") {
                const module = __webpack_require__(id);
                if (typeof module.default === "undefined")
                    module.default = module;
                return module;
            }
        },
        resolve() {
            if (false) {
                return require.resolve("Src/pages/SearchPage/SearchPage");
            }
            else {
                return require.resolveWeak("Src/pages/SearchPage/SearchPage");
            }
        }
    }),
    [PAGE_TYPES.tag]: loadable({
        chunkName() { return "f5a6d735358953a95b00717224ea41d1"; },
        requireAsync() {
            if (true) {
                return import(/*webpackChunkName: "f5a6d735358953a95b00717224ea41d1"*/
                'Src/pages/TagPage');
            }
            else {
                return Promise.resolve(this.requireSync());
            }
        },
        isReady() {
            if (typeof __webpack_modules__ !== "undefined") {
                return Boolean(__webpack_modules__[this.resolve()]);
            }
            return false;
        },
        requireSync() {
            const id = this.resolve();
            if (typeof __webpack_require__ !== "undefined") {
                const module = __webpack_require__(id);
                if (typeof module.default === "undefined")
                    module.default = module;
                return module;
            }
        },
        resolve() {
            if (false) {
                return require.resolve("Src/pages/TagPage");
            }
            else {
                return require.resolveWeak("Src/pages/TagPage");
            }
        }
    }),
    [PAGE_TYPES.authorDetail]: loadable({
        chunkName() { return "6000c82de646da35a386b04ae121685c"; },
        requireAsync() {
            if (true) {
                return import(/*webpackChunkName: "6000c82de646da35a386b04ae121685c"*/
                'Src/pages/AuthorPage');
            }
            else {
                return Promise.resolve(this.requireSync());
            }
        },
        isReady() {
            if (typeof __webpack_modules__ !== "undefined") {
                return Boolean(__webpack_modules__[this.resolve()]);
            }
            return false;
        },
        requireSync() {
            const id = this.resolve();
            if (typeof __webpack_require__ !== "undefined") {
                const module = __webpack_require__(id);
                if (typeof module.default === "undefined")
                    module.default = module;
                return module;
            }
        },
        resolve() {
            if (false) {
                return require.resolve("Src/pages/AuthorPage");
            }
            else {
                return require.resolveWeak("Src/pages/AuthorPage");
            }
        }
    }),
    [PAGE_TYPES.names]: loadable({
        chunkName() { return "a56d1b1a6ee9db31fecde895b4639e4a"; },
        requireAsync() {
            if (true) {
                return import(/*webpackChunkName: "a56d1b1a6ee9db31fecde895b4639e4a"*/
                'Src/pages/NamesPage/NamesPage');
            }
            else {
                return Promise.resolve(this.requireSync());
            }
        },
        isReady() {
            if (typeof __webpack_modules__ !== "undefined") {
                return Boolean(__webpack_modules__[this.resolve()]);
            }
            return false;
        },
        requireSync() {
            const id = this.resolve();
            if (typeof __webpack_require__ !== "undefined") {
                const module = __webpack_require__(id);
                if (typeof module.default === "undefined")
                    module.default = module;
                return module;
            }
        },
        resolve() {
            if (false) {
                return require.resolve("Src/pages/NamesPage/NamesPage");
            }
            else {
                return require.resolveWeak("Src/pages/NamesPage/NamesPage");
            }
        }
    }),
    [PAGE_TYPES.user]: loadable({
        chunkName() { return "60f09b63178d220e03b5824f6cd7b8bf"; },
        requireAsync() {
            if (true) {
                return import(/*webpackChunkName: "60f09b63178d220e03b5824f6cd7b8bf"*/
                'Src/pages/UserPage');
            }
            else {
                return Promise.resolve(this.requireSync());
            }
        },
        isReady() {
            if (typeof __webpack_modules__ !== "undefined") {
                return Boolean(__webpack_modules__[this.resolve()]);
            }
            return false;
        },
        requireSync() {
            const id = this.resolve();
            if (typeof __webpack_require__ !== "undefined") {
                const module = __webpack_require__(id);
                if (typeof module.default === "undefined")
                    module.default = module;
                return module;
            }
        },
        resolve() {
            if (false) {
                return require.resolve("Src/pages/UserPage");
            }
            else {
                return require.resolveWeak("Src/pages/UserPage");
            }
        }
    }),
    [PAGE_TYPES.author_listing]: loadable({
        chunkName() { return "ac1a0b07e5c345ac0313423a0f2b82fc"; },
        requireAsync() {
            if (true) {
                return import(/*webpackChunkName: "ac1a0b07e5c345ac0313423a0f2b82fc"*/
                'Src/pages/AuthorListingPage');
            }
            else {
                return Promise.resolve(this.requireSync());
            }
        },
        isReady() {
            if (typeof __webpack_modules__ !== "undefined") {
                return Boolean(__webpack_modules__[this.resolve()]);
            }
            return false;
        },
        requireSync() {
            const id = this.resolve();
            if (typeof __webpack_require__ !== "undefined") {
                const module = __webpack_require__(id);
                if (typeof module.default === "undefined")
                    module.default = module;
                return module;
            }
        },
        resolve() {
            if (false) {
                return require.resolve("Src/pages/AuthorListingPage");
            }
            else {
                return require.resolveWeak("Src/pages/AuthorListingPage");
            }
        }
    }),
    [PAGE_TYPES.consultantAsk]: loadable({
        chunkName() { return "98ad00c919030f48e774c3dbf918008f"; },
        requireAsync() {
            if (true) {
                return import(/*webpackChunkName: "98ad00c919030f48e774c3dbf918008f"*/
                'Src/pages/AskQuestionPage');
            }
            else {
                return Promise.resolve(this.requireSync());
            }
        },
        isReady() {
            if (typeof __webpack_modules__ !== "undefined") {
                return Boolean(__webpack_modules__[this.resolve()]);
            }
            return false;
        },
        requireSync() {
            const id = this.resolve();
            if (typeof __webpack_require__ !== "undefined") {
                const module = __webpack_require__(id);
                if (typeof module.default === "undefined")
                    module.default = module;
                return module;
            }
        },
        resolve() {
            if (false) {
                return require.resolve("Src/pages/AskQuestionPage");
            }
            else {
                return require.resolveWeak("Src/pages/AskQuestionPage");
            }
        }
    }),
    [PAGE_TYPES.market]: loadable({
        chunkName() { return "702cb9fe6c2bffdff1364ea479bee2e2"; },
        requireAsync() {
            if (true) {
                return import(/*webpackChunkName: "702cb9fe6c2bffdff1364ea479bee2e2"*/
                'Src/pages/MarketMainPage');
            }
            else {
                return Promise.resolve(this.requireSync());
            }
        },
        isReady() {
            if (typeof __webpack_modules__ !== "undefined") {
                return Boolean(__webpack_modules__[this.resolve()]);
            }
            return false;
        },
        requireSync() {
            const id = this.resolve();
            if (typeof __webpack_require__ !== "undefined") {
                const module = __webpack_require__(id);
                if (typeof module.default === "undefined")
                    module.default = module;
                return module;
            }
        },
        resolve() {
            if (false) {
                return require.resolve("Src/pages/MarketMainPage");
            }
            else {
                return require.resolveWeak("Src/pages/MarketMainPage");
            }
        }
    }),
    [PAGE_TYPES.marketCategory]: loadable({
        chunkName() { return "ec6f6ad1b54dd52a8e13a3f578f48803"; },
        requireAsync() {
            if (true) {
                return import(/*webpackChunkName: "ec6f6ad1b54dd52a8e13a3f578f48803"*/
                'Src/pages/MarketCategoryPage');
            }
            else {
                return Promise.resolve(this.requireSync());
            }
        },
        isReady() {
            if (typeof __webpack_modules__ !== "undefined") {
                return Boolean(__webpack_modules__[this.resolve()]);
            }
            return false;
        },
        requireSync() {
            const id = this.resolve();
            if (typeof __webpack_require__ !== "undefined") {
                const module = __webpack_require__(id);
                if (typeof module.default === "undefined")
                    module.default = module;
                return module;
            }
        },
        resolve() {
            if (false) {
                return require.resolve("Src/pages/MarketCategoryPage");
            }
            else {
                return require.resolveWeak("Src/pages/MarketCategoryPage");
            }
        }
    }),
    [PAGE_TYPES.marketProduct]: loadable({
        chunkName() { return "a60f3eab155914db50a12c4ff993312c"; },
        requireAsync() {
            if (true) {
                return import(/*webpackChunkName: "a60f3eab155914db50a12c4ff993312c"*/
                'Src/pages/MarketProductPage');
            }
            else {
                return Promise.resolve(this.requireSync());
            }
        },
        isReady() {
            if (typeof __webpack_modules__ !== "undefined") {
                return Boolean(__webpack_modules__[this.resolve()]);
            }
            return false;
        },
        requireSync() {
            const id = this.resolve();
            if (typeof __webpack_require__ !== "undefined") {
                const module = __webpack_require__(id);
                if (typeof module.default === "undefined")
                    module.default = module;
                return module;
            }
        },
        resolve() {
            if (false) {
                return require.resolve("Src/pages/MarketProductPage");
            }
            else {
                return require.resolveWeak("Src/pages/MarketProductPage");
            }
        }
    }),
    [PAGE_TYPES.marketSearch]: loadable({
        chunkName() { return "ce20e571367a5009568453469254ec7b"; },
        requireAsync() {
            if (true) {
                return import(/*webpackChunkName: "ce20e571367a5009568453469254ec7b"*/
                'Src/pages/MarketSearchPage');
            }
            else {
                return Promise.resolve(this.requireSync());
            }
        },
        isReady() {
            if (typeof __webpack_modules__ !== "undefined") {
                return Boolean(__webpack_modules__[this.resolve()]);
            }
            return false;
        },
        requireSync() {
            const id = this.resolve();
            if (typeof __webpack_require__ !== "undefined") {
                const module = __webpack_require__(id);
                if (typeof module.default === "undefined")
                    module.default = module;
                return module;
            }
        },
        resolve() {
            if (false) {
                return require.resolve("Src/pages/MarketSearchPage");
            }
            else {
                return require.resolveWeak("Src/pages/MarketSearchPage");
            }
        }
    }),
    [PAGE_TYPES.marketQuiz]: loadable({
        chunkName() { return "adcd99d0d026890417f7f17f262d1f94"; },
        requireAsync() {
            if (true) {
                return import(/*webpackChunkName: "adcd99d0d026890417f7f17f262d1f94"*/
                'Src/pages/MarketQuizPage');
            }
            else {
                return Promise.resolve(this.requireSync());
            }
        },
        isReady() {
            if (typeof __webpack_modules__ !== "undefined") {
                return Boolean(__webpack_modules__[this.resolve()]);
            }
            return false;
        },
        requireSync() {
            const id = this.resolve();
            if (typeof __webpack_require__ !== "undefined") {
                const module = __webpack_require__(id);
                if (typeof module.default === "undefined")
                    module.default = module;
                return module;
            }
        },
        resolve() {
            if (false) {
                return require.resolve("Src/pages/MarketQuizPage");
            }
            else {
                return require.resolveWeak("Src/pages/MarketQuizPage");
            }
        }
    }),
    [PAGE_TYPES.quiz]: loadable({
        chunkName() { return "371cc4c23da388468fba7494c5946b7b"; },
        requireAsync() {
            if (true) {
                return import(/*webpackChunkName: "371cc4c23da388468fba7494c5946b7b"*/
                'Src/pages/QuizPage');
            }
            else {
                return Promise.resolve(this.requireSync());
            }
        },
        isReady() {
            if (typeof __webpack_modules__ !== "undefined") {
                return Boolean(__webpack_modules__[this.resolve()]);
            }
            return false;
        },
        requireSync() {
            const id = this.resolve();
            if (typeof __webpack_require__ !== "undefined") {
                const module = __webpack_require__(id);
                if (typeof module.default === "undefined")
                    module.default = module;
                return module;
            }
        },
        resolve() {
            if (false) {
                return require.resolve("Src/pages/QuizPage");
            }
            else {
                return require.resolveWeak("Src/pages/QuizPage");
            }
        }
    }),
    [PAGE_TYPES.userContent]: loadable({
        chunkName() { return "0e8b4ce7b3417fc2a102dfc1b04758f6"; },
        requireAsync() {
            if (true) {
                return import(/*webpackChunkName: "0e8b4ce7b3417fc2a102dfc1b04758f6"*/
                'Src/pages/ContestPage/ContestPage');
            }
            else {
                return Promise.resolve(this.requireSync());
            }
        },
        isReady() {
            if (typeof __webpack_modules__ !== "undefined") {
                return Boolean(__webpack_modules__[this.resolve()]);
            }
            return false;
        },
        requireSync() {
            const id = this.resolve();
            if (typeof __webpack_require__ !== "undefined") {
                const module = __webpack_require__(id);
                if (typeof module.default === "undefined")
                    module.default = module;
                return module;
            }
        },
        resolve() {
            if (false) {
                return require.resolve("Src/pages/ContestPage/ContestPage");
            }
            else {
                return require.resolveWeak("Src/pages/ContestPage/ContestPage");
            }
        }
    }),
    [PAGE_TYPES.collections]: loadable({
        chunkName() { return "3a7004dd293c572a539d42ebb30314d1"; },
        requireAsync() {
            if (true) {
                return import(/*webpackChunkName: "3a7004dd293c572a539d42ebb30314d1"*/
                'Src/pages/CollectionPage');
            }
            else {
                return Promise.resolve(this.requireSync());
            }
        },
        isReady() {
            if (typeof __webpack_modules__ !== "undefined") {
                return Boolean(__webpack_modules__[this.resolve()]);
            }
            return false;
        },
        requireSync() {
            const id = this.resolve();
            if (typeof __webpack_require__ !== "undefined") {
                const module = __webpack_require__(id);
                if (typeof module.default === "undefined")
                    module.default = module;
                return module;
            }
        },
        resolve() {
            if (false) {
                return require.resolve("Src/pages/CollectionPage");
            }
            else {
                return require.resolveWeak("Src/pages/CollectionPage");
            }
        }
    }),
    [PAGE_TYPES.addPet]: loadable({
        chunkName() { return "c0e130c7ce6adaae00fc9b353c6f2f1c"; },
        requireAsync() {
            if (true) {
                return import(/*webpackChunkName: "c0e130c7ce6adaae00fc9b353c6f2f1c"*/
                'Src/pages/AddPetPage');
            }
            else {
                return Promise.resolve(this.requireSync());
            }
        },
        isReady() {
            if (typeof __webpack_modules__ !== "undefined") {
                return Boolean(__webpack_modules__[this.resolve()]);
            }
            return false;
        },
        requireSync() {
            const id = this.resolve();
            if (typeof __webpack_require__ !== "undefined") {
                const module = __webpack_require__(id);
                if (typeof module.default === "undefined")
                    module.default = module;
                return module;
            }
        },
        resolve() {
            if (false) {
                return require.resolve("Src/pages/AddPetPage");
            }
            else {
                return require.resolveWeak("Src/pages/AddPetPage");
            }
        }
    }),
};
const Pages: FunctionComponent = () => {
    const { page_type } = useAppContext();
    if (!page_type) {
        return null;
    }
    const PageComponent = components[page_type];
    return PageComponent ? <PageComponent /> : null;
};
export default Pages;
